import { Box, Button, CircularProgress, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { ITransactionHistory } from '../../../models/Inquiry/TransactionHistory/ITransactionHistory';
import { IDebtor } from '../../../models/NotificationCenter/IDebtor';
import { useGlobalState } from '../../../store/GlobalStore';
import useStyles from '../AgentNCCss/AgentNotificationCenterCss';
import LoadMore from '../../../images/Icons/LoadMore.svg';

const NCAccountHistory: React.FC<{ debtors: IDebtor, histories: ITransactionHistory[], mapped: boolean, handleLoadMore: () => void }> = (props) => {
    const { histories, handleLoadMore } = props
    const classes = useStyles();
    const { state } = useGlobalState();

    const useProgressStyles = makeStyles((theme) => ({
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        top: {
            color: '#1a90ff',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    }));

    function Progress(props) {
        const classes = useProgressStyles();
        return (
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    size={40}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.top}
                    classes={{
                        circle: classes.circle,
                    }}
                    size={40}
                    thickness={4}
                    {...props}
                />
            </div>
        );
    }

    return (
        <React.Fragment >
            <Box p={0} style={{ padding: '0px 10px' }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <h3 className={classes.typoTitle}> Notes</h3>

                    <Button id="Inquiry_LoadAll_Button" className={classes.loadmorebutton} variant="contained" color="primary" onClick={handleLoadMore} >
                        <img src={LoadMore} alt="Load_More" className={classes.loadmoreimage} />
                        Load More
                    </Button>
                </Box>
                <Box p={1} width="100%" flexShrink={0} bgcolor="white" className={classes.rootHistory} >
                    <Scrollbars autoHide
                        autoHideTimeout={1000}
                        autoHideDuration={10}
                        autoHeight
                        autoHeightMin={150}
                        autoHeightMax={150}
                        width="100%">
                        {histories.length > 0 ?
                            histories.map((Histories) => {
                                if (Histories.activityType !== "0") {
                                    return (
                                        <p className={Histories.activityType === "T" ? classes.typoRecordData1 : classes.typoRecordData2}>
                                            {moment(Histories.activityDt).format(state.GlobalUtils?.settingValue)}
                                            &nbsp;{Histories.activity?.split('|')[0]}
                                        </p>
                                    )
                                } else {
                                    return (
                                        < Typography variant="h6" gutterBottom className={classes.ErrorMessageStyle}>
                                            No Records To Display
                                        </Typography>
                                    )
                                }
                            })
                            : <Progress />
                        }
                    </Scrollbars>
                </Box>
            </Box>
        </React.Fragment>
    )
}

export default NCAccountHistory
